import React, { useRef, useState, useEffect } from 'react'
import Dropdown from 'meinian-package/src/baseComponent/dropdown'
import classNames from 'classnames'
import styles from './index.module.less'

export default ({ label, value, mb12 = true, style = null }) => {
  const wrapDom = useRef(null)
  const [hasMore, setHasMore] = useState(false)
  const [open, setOpen] = useState(false)
  useEffect(() => {
    if (wrapDom.current.scrollHeight > 25) {
      setHasMore(true)
    }
  }, [wrapDom.current?.scrollHeight])
  return <div className={classNames(styles['mn-style-item'], { mb12 })} style={style}>
    <div className="label">{label}</div>
    <div className="value-wrap-wrap">
      <div className="value-wrap" ref={wrapDom}>
        <div className={classNames('value', { empty: !value, 'text-overflow': hasMore })}>{ value || '未填写'}</div>
      </div>
      {
        hasMore && <Dropdown
          open={open}
          onOpenChange={vis => setOpen(vis)}
          trigger="click"
          overlay={<div className="item-more-wrap">{
            value
          }</div>}
          getPopupContainer={triggerNode => triggerNode.parentElement}
        >
          <div className={classNames('item', 'fill-white-bg', { more: true, active: open })}>详情</div>
        </Dropdown>
      }
    </div>
  </div>
}
